import appLinksConfig from "./appLinksConfig.json";

export const EVO_DEEP_LINK = appLinksConfig.evoDeepLink;
export const APP_STORE_URL = appLinksConfig.appStoreUrl;
export const GOOGLE_PLAY_URL = appLinksConfig.googlePlayUrl;
export const APP_DOWNLOAD_URL = appLinksConfig.appDownloadUrl;

export type AppPlatform = "ios" | "android" | "desktop";

export function detectAppPlatform(): AppPlatform {
  if (typeof navigator === "undefined") return "desktop";

  const userAgent = navigator.userAgent || "";
  const platform = [
    navigator.platform || "",
    (
      navigator as Navigator & {
        userAgentData?: { platform?: string };
      }
    ).userAgentData?.platform || "",
  ].join(" ");

  if (/android/i.test(`${userAgent} ${platform}`)) return "android";
  if (/ipad|iphone|ipod/i.test(userAgent)) return "ios";
  if (/mac/i.test(platform) && navigator.maxTouchPoints > 1) return "ios";

  return "desktop";
}

export function storeUrlForPlatform(
  platform: AppPlatform,
) {
  return platform === "android" ? GOOGLE_PLAY_URL : APP_STORE_URL;
}
